import dayjs from 'dayjs';

// const encrypt = require("../commons/encrypt/encrypt");
const { decompress } = require('shrink-string')
const { cryptr_decrypt, cryptr_encrypt } = require("../commons/encrypt/encrypt");

async function getEncAuth() {
  const now = dayjs()
  const expiredTime = now.add(2, 'minute')
  let auth = { api_key: process.env.REACT_APP_API_KEY, expired: expiredTime }
  let encrypted = await cryptr_encrypt().encrypt(JSON.stringify(auth))
  return encrypted
}

const getListFood = async (b) => {
  let result = null;
  try {
    let url = process.env.REACT_APP_API_URL + "fnb-ol-get-food";
    let encrypted = await getEncAuth();
    let enc = await cryptr_encrypt().encrypt(JSON.stringify(b))
    await fetch(url, {
      method: "POST",
      headers: {
        Authorization: encrypted,
        Accept: "application/json",
        "Content-Type": "application/json",
        AppMode: 'attendance'
      }, body: JSON.stringify({
        p1: enc
      }),
    })
      .then(response => response.json())
      .then(async x => {
        if (x.code === "GD-01") {
          let decompressed = await decompress(x.token)
          const decrypted = await cryptr_decrypt().decrypt(decompressed);
          result = JSON.parse(decrypted)
        }
      });
  } catch (e) {
    console.log(e)
    result = null
  } finally {
    return result;
  }
}

const getListBeverage = async (b) => {
  let result = null;
  try {
    let url = process.env.REACT_APP_API_URL + "fnb-ol-get-beverage";
    let encrypted = await getEncAuth();
    let enc = await cryptr_encrypt().encrypt(JSON.stringify(b))
    await fetch(url, {
      method: "POST",
      headers: {
        Authorization: encrypted,
        Accept: "application/json",
        "Content-Type": "application/json",
        AppMode: 'attendance'
      }, body: JSON.stringify({
        p1: enc
      }),
    })
      .then(response => response.json())
      .then(async x => {
        if (x.code === "GD-01") {
          let decompressed = await decompress(x.token)
          const decrypted = await cryptr_decrypt().decrypt(decompressed);
          result = JSON.parse(decrypted)
        }
      });
  } catch (e) {
    result = null
  } finally {
    return result;
  }
}

const getListDessert = async (b) => {
  let result = null;
  try {
    let url = process.env.REACT_APP_API_URL + "fnb-ol-get-dessert";
    let encrypted = await getEncAuth();
    let enc = await cryptr_encrypt().encrypt(JSON.stringify(b))
    await fetch(url, {
      method: "POST",
      headers: {
        Authorization: encrypted,
        Accept: "application/json",
        "Content-Type": "application/json",
        AppMode: 'attendance'
      }, body: JSON.stringify({
        p1: enc
      }),
    })
      .then(response => response.json())
      .then(async x => {
        if (x.code === "GD-01") {
          let decompressed = await decompress(x.token)
          const decrypted = await cryptr_decrypt().decrypt(decompressed);
          result = JSON.parse(decrypted)
        }
      });
  } catch (e) {
    result = null
  } finally {
    return result;
  }
}


const getOrderListData = async (b) => {
  let result = null;
  try {
    let url = process.env.REACT_APP_API_URL + "fnb-ol-data";
    let encrypted = await getEncAuth();

    let enc = await cryptr_encrypt().encrypt(JSON.stringify(b))
    await fetch(url, {
      method: "POST",
      headers: {
        Authorization: encrypted,
        Accept: "application/json",
        "Content-Type": "application/json",
        AppMode: 'attendance',
      }, body: JSON.stringify({
        p1: enc
      }),
    })
      .then(response => response.json())
      .then(async x => {
        if (x.code === "GD-01") {
          let decompressed = await decompress(x.token)
          const decrypted = await cryptr_decrypt().decrypt(decompressed);
          result = JSON.parse(decrypted)
        } else if (x.message === "GD-00") {
          result = { data: null };
        }
      });
  } catch (e) {
    result = null
  } finally {
    return result;
  }
}

const submitOrder = async (b) => {
  let result = null;
  try {
    let url = process.env.REACT_APP_API_URL + "fnb-submit-order";
    let encrypted = await getEncAuth();

    let enc = await cryptr_encrypt().encrypt(JSON.stringify(b))
    await fetch(url, {
      method: "POST",
      headers: {
        Authorization: encrypted,
        Accept: "application/json",
        "Content-Type": "application/json",
        AppMode: 'attendance',
      }, body: JSON.stringify({
        p1: enc
      }),
    })
      .then(response => response.json())
      .then(async x => {
        result = x
      });
  } catch (e) {
    result = null
  } finally {
    return result;
  }
}


export {
  getListFood,
  getListBeverage,
  getListDessert,
  getOrderListData,
  submitOrder
}